import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';
import { USUARIO_LISTADO } from '../usuario/usuarioActions';

const API = `${consts.API_URL}/aplicacao`;

export const APLICACAO_MODO_TELA = 'APLICACAO_MODO_TELA';
export const APLICACAO_AGUARDANDO = 'APLICACAO_AGUARDANDO';
export const APLICACAO_LISTADA = 'APLICACAO_LISTADA';
export const APLICACAO_OPCOES = 'APLICACAO_OPCOES';
export const APLICACAO_AREAS = 'APLICACAO_AREAS';
export const APLICACAO_HISTORICO = 'APLICACAO_HISTORICO';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString();
    const retorno = Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    );

    return Number.isFinite(retorno) ? retorno : null;
};

const dataHoraUtc = valor => {
    if (
        !valor ||
        /Z$/i.test(valor) ||
        /[+-]\d{2}:\d{2}$/.test(valor)
    ) {
        return valor;
    }

    const data = new Date(valor);
    return Number.isNaN(data.getTime())
        ? valor
        : data.toISOString();
};

const normalizar = registro => ({
    ...registro,
    datahora_solicitacao:
        dataHoraUtc(registro.datahora_solicitacao),
    id_cliente: Number(registro.id_cliente) || null,
    id_tipo: Number(registro.id_tipo) || null,
    valor_aplicacao:
        numero(registro.valor_aplicacao),
    ids_veiculos: (registro.ids_veiculos || []).map(Number),
    areas: (registro.areas || []).map(area => {
        const hectares = numero(area.area_hectares);
        const preco = numero(area.preco_unitario);
        const total =
            hectares === null || preco === null
                ? null
                : Math.round(hectares * preco * 100) / 100;
        const desconto = numero(area.valor_desconto) || 0;

        return {
            ...area,
            id_cliente_area:
                Number(area.id_cliente_area) || null,
            id_produto: Number(area.id_produto) || null,
            id_unidade_medida:
                Number(area.id_unidade_medida) || null,
            area_hectares: hectares,
            preco_unitario: preco,
            valor_total: total,
            valor_desconto: desconto,
            valor_final:
                total === null ? null : total - desconto
        };
    })
});

export const setModoTela = (modo, registro = {}) => ({
    type: APLICACAO_MODO_TELA,
    payload: { modo, registro }
});

export const setAguardando = aguardando => ({
    type: APLICACAO_AGUARDANDO,
    payload: aguardando
});

export function initForm(registro = {}) {
    let datahora = registro.datahora_solicitacao;

    if (datahora) {
        const data = new Date(datahora);

        if (!Number.isNaN(data.getTime())) {
            data.setMinutes(
                data.getMinutes() - data.getTimezoneOffset()
            );
            datahora = data.toISOString().substring(0, 16);
        }
    }

    return initialize('aplicacaoForm', {
        ...normalizar(registro),
        datahora_solicitacao: datahora,
        ids_areas_excluidas: []
    });
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(API);
            dispatch({
                type: APLICACAO_LISTADA,
                payload: resp.data
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getOpcoes() {
    return async dispatch => {
        try {
            const resp = await axios.get(`${API}/opcoes`);
            dispatch({
                type: APLICACAO_OPCOES,
                payload: resp.data
            });
            dispatch({
                type: USUARIO_LISTADO,
                payload: {
                    data: resp.data.usuarios || []
                }
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function getAreas(idCliente) {
    return async dispatch => {
        if (!idCliente) {
            dispatch({
                type: APLICACAO_AREAS,
                payload: []
            });
            return;
        }

        try {
            const resp = await axios.get(`${API}/areas`, {
                params: { id_cliente: idCliente }
            });
            dispatch({
                type: APLICACAO_AREAS,
                payload: resp.data
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function getHistorico(idAplicacao) {
    return async dispatch => {
        if (!idAplicacao) {
            dispatch({
                type: APLICACAO_HISTORICO,
                payload: []
            });
            return;
        }

        try {
            const resp = await axios.get(`${API}/historico`, {
                params: { id_aplicacao: idAplicacao }
            });
            dispatch({
                type: APLICACAO_HISTORICO,
                payload: resp.data
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = normalizar(registro);

            if (dados.id) {
                await axios.put(API, dados);
            } else {
                await axios.post(API, dados);
            }

            setSuccess(
                dados.id
                    ? 'Aplicação atualizada.'
                    : 'Pedido de aplicação criado.'
            );
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function alterarStatus(registro, codigo) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const dados = normalizar(registro);
            const status = (
                getState().aplicacao.status || []
            ).find(item => item.codigo === codigo);

            if (!status) {
                return;
            }

            if (
                ['PEDIDO', 'AGUARDANDO_APROVACAO']
                    .includes(registro.status)
            ) {
                await axios.put(API, dados);
            }

            await axios.put(`${API}/status`, {
                ...dados,
                id_status_destino: status.id
            });

            const mensagens = {
                PEDIDO: 'Aplicação reaberta para ajustes.',
                AGUARDANDO_APROVACAO:
                    'Pedido enviado para aprovação.',
                AGUARDANDO_APLICACAO:
                    'Aplicação aprovada.',
                FINALIZADO: 'Aplicação finalizada.'
            };

            setSuccess(mensagens[codigo]);
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            await axios.delete(API, {
                params: { id: registro.id }
            });
            setSuccess('Pedido excluído.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
